<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port Number</th>
        <th class="text-sm">Port Name</th>
        <th class="text-sm">Status</th>
        <th class="text-sm">Online ONUs</th>
        <th class="text-sm">Offline ONUs</th>
        <th class="text-sm">Speed</th>
        <th class="text-sm">Duplex</th>
        <th class="text-sm">Negotiation Mode</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="8">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="hasPortData">
        <tr
          v-for="(port, index) in portDataArray"
          :key="index"
        >
          <td class="text-sm font-weight-bold">{{ port.portNum || port.port_num || 'N/A' }}</td>
          <td class="text-sm">{{ port.portName || port.port_name || 'N/A' }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getStatusClass(port.portStatus)"
              style="text-transform: uppercase; color: #fff !important;"
            >
              {{ getStatusText(port.portStatus) }}
            </span>
          </td>
          <td class="text-sm">
            {{ port.online || 0 }}
          </td>
          <td class="text-sm">
            {{ port.offline || 0 }}
          </td>
          <td class="text-sm">{{ formatSpeed(port.portSpeed) }}</td>
          <td class="text-sm">{{ formatDuplex(port.portDuplex) }}</td>
          <td class="text-sm">{{ port.negotiationMode || 'N/A' }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="8" class="text-center">
            <Skalaton />
            <!-- No port status data available -->
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'TbsEponPortStatusTable',
  components: {
    Skalaton
  },
  props: {
    portInfo: {
      type: [Array, Object],
      default: () => []
    },
    loading: Boolean
  },
  computed: {
    hasPortData() {
      if (Array.isArray(this.portInfo)) {
        return this.portInfo.length > 0;
      }
      if (this.portInfo && typeof this.portInfo === 'object') {
        if (this.portInfo.ports && Array.isArray(this.portInfo.ports)) {
          return this.portInfo.ports.length > 0;
        }
        if (this.portInfo.data && Array.isArray(this.portInfo.data)) {
          return this.portInfo.data.length > 0;
        }
        return Object.keys(this.portInfo).length > 0;
      }
      return false;
    },
    portDataArray() {
      if (Array.isArray(this.portInfo)) {
        return this.portInfo;
      }
      if (this.portInfo && typeof this.portInfo === 'object') {
        if (this.portInfo.ports && Array.isArray(this.portInfo.ports)) {
          return this.portInfo.ports;
        }
        if (this.portInfo.data && Array.isArray(this.portInfo.data)) {
          return this.portInfo.data;
        }
        return [];
      }
      return [];
    }
  },
  methods: {
    getStatusClass(status) {
      if (status === '1' || status === 1) return 'bg-success';
      if (status === '0' || status === 0) return 'bg-danger';
      return 'bg-warning';
    },
    getStatusText(status) {
      if (status === '1' || status === 1) return 'Up';
      if (status === '0' || status === 0) return 'Down';
      return 'Unknown';
    },
    formatSpeed(speed) {
      if (!speed) return 'N/A';
      const num = parseFloat(speed);
      if (isNaN(num)) return speed;
      if (num >= 10000) return `${num / 1000}G`;
      return `${num}M`;
    },
    formatDuplex(duplex) {
      if (duplex === '1' || duplex === 1) return 'Full';
      if (duplex === '0' || duplex === 0) return 'Half';
      return 'N/A';
    }
  }
}
</script>

